import { ItemUrls } from '../api/item-urls';
import { ClaimsUrls } from '../api/item-with-sinisters';

export * from '../api/item-urls';

export const EndPoints = {
    ItemUrls,
    ClaimsUrls
}
